<div class="container-fluid background-transparent pt-0">
  <app-trial-license-warning></app-trial-license-warning>
  <lib-campaigns></lib-campaigns>
</div>

<div class="content-inner background-section">
  <div class="title-bar background-transparent">
    <a class="back-button mt-2 mb-4" (click)="emitData({key:'back'})"><img class="svg mr-2 ml-4 back-button"
        src="assets/ph-bhp-layout/svg/back.svg" /> {{ translationKeys.SOPObservation.Back | translate}}</a>
    <div class="container-fluid d-md-flex justify-content-between background-transparent">
      <h2 class="page-title">{{ translationKeys.Configure.Quota | translate }}</h2>
      <div>
        <lib-ph-bhp-observe-chart-export #exportTag [gridData]="gridData" [exportComponent]="compliance"
          [filter]="filter" [fields]="fields" [select]="'quota'" (childData)="emitData($event)" [fileName]="pageTitle"
          [appName]="appName" class="col p-0" [clickImageBtn]="clickImageBtn" [clickExcelBtn]="clickExcelBtn"
          [clickPdfBtn]="clickPdfBtn" [userData]="appConfig.userData"
          (resetClickBtn)="resetExportAs($event)"></lib-ph-bhp-observe-chart-export>
      </div>
    </div>
  </div>
  <div class="evaluation-section container-fluid reportFiter">
    <div class="row">
      <div class="col my-3 d-flex  justify-content-end">
        <button class="btn-link-reset" (click)="resetFilters()" *ngIf="userHasFilter">{{ 'EVALUATION.RESET_FILTERS' | translate }}</button>
        <button class="btn-cancel-bordered-bd" (click)="openFilter()" *ngIf="!userHasFilter">{{ 'EVALUATION.ADD_FILTER' | translate }}</button>
      </div>
    </div>
    <lib-ph-bhp-filter #filter [userData]="userData" [hideProfessionalSubcategory]="true" [unlockMaxDate]="true"
      [evaluationLoaded]="evaluationLoaded" (filterSaved)="onFilterSaved()" [filterIndex]="0"
      [userHasFilter]="userHasFilter" [isMultiselectReport]="false"></lib-ph-bhp-filter>
    <div class="row">
      <div class="col my-3 d-flex  justify-content-end">
        <div class="dropdown dropdown-bhp">
          <div class="dropdown-container-input" [ngClass]="!userHasFilter ? 'disabled' : ''" data-toggle="dropdown"
            aria-expanded="false">
            <div class="d-flex align-items-center">
              <img class="dropdown-arrow mr-2"
                src="{{ !userHasFilter ? 'assets/icons/downloadDarkOutlined-disabled.svg' : 'assets/icons/downloadDarkOutlined.svg' }}" />
              <label [ngClass]="!userHasFilter ? 'disabled-export' : ''">{{ 'EVALUATION.EXPORT' | translate }}</label>
            </div>
            <img class="dropdown-arrow"
              src="{{ !userHasFilter ? 'assets/icons/arrowDropdownOutlined-disabled.svg' : 'assets/icons/arrowDropdownOutlined.svg' }}" />
          </div>
          <ul class="dropdown-menu">
            <li class="dropdown-item" *ngIf="gridData" (click)="excelDownload()">{{ 'GENERAL.EXCEL' | translate }}</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="col-12 static-card first-card">
      <div class="row">
        <h1 class="section-title col-md-6">{{ translationKeys.Configure.Quota | translate }}</h1>
        <div [ngClass]="!noDataFound ? 'active-refresh' : 'inactive-refresh'"
          class="justify-content-end col-md-6 refresh-box" (click)="onRefreshClick(noDataFound)">
          <img *ngIf="!noDataFound" src="assets/ph-bhp-evaluation/icon-refresh-active.svg" />
          <img *ngIf="noDataFound" src="assets/ph-bhp-evaluation/icon-refresh-inactive.svg" />
          <span>{{ 'CONFIGURE.FILTERS.REFRESH' | translate }}</span>
        </div>
      </div>
      <bd-light-table [gridData]="gridData || []" [pageInfo]="pageInfo" [fields]="fields" [hasSubtitles]="true"
        [isEvaluationTable]="isEvaluationTable" [chartType]="'filter'" *ngIf="userHasFilter"></bd-light-table>
      <div class="no-data-box" *ngIf="!userHasFilter">
        <span class="no-data-text">{{ 'CONFIGURE.FILTERS.NO_FILTER_FOUND' | translate }}</span>
      </div>
    </div>
  </div>
  <div class="quota-note">
    * {{'EVALUATION.QUOTA_DIFFER' | translate}}
  </div>
</div>
<lib-ph-bhp-pdf-compliance #compliance></lib-ph-bhp-pdf-compliance>